// extracted by mini-css-extract-plugin
export default {"zoomModal":"R4-z"};